/* Optional adapter uses a Shopify fixed bundle. The adapter component is never
   published as a standalone item, so checkout cannot leave it without the main item. */
(() => {
  if (window.BallrAddon) return;
  function picker(form) { return form?.querySelector('ballr-addon-picker'); }
  function mapping(form) { return JSON.parse(picker(form)?.querySelector('[data-addon-map]')?.textContent || '{}'); }
  function resolve(form, id, selected = picker(form)?.querySelector('[data-addon-choice]')?.checked) {
    if (!selected) return String(id);
    const option = mapping(form)[String(id)];
    if (!option?.id || !option.available) throw new Error(picker(form)?.dataset.error || 'Add-on unavailable');
    return String(option.id);
  }
  window.BallrAddon = {
    resolve,
    apply(form, data) { data.set('id', resolve(form, data.get('id'))); },
    capture(form) {
      if (!picker(form)?.querySelector('[data-addon-choice]')?.checked) return null;
      return JSON.stringify(Object.fromEntries(Object.entries(mapping(form)).filter(([,v]) => v.available)));
    },
  };
  class AddonPicker extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.choice = this.querySelector('[data-addon-choice]');
      if (!this.form || !this.choice) return;
      this.update = () => {
        const id = this.form.querySelector('input[name="id"]')?.value;
        const data = mapping(this.form)[id];
        this.hidden = !data || !data.available || data.delta <= 0;
        this.choice.disabled = this.hidden;
        if (this.hidden) this.choice.checked = false;
        this.querySelector('[data-addon-price]').textContent = data ? '+ ' + data.price : '';
      };
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.form, { subtree:true, attributes:true, attributeFilter:['value'] });
      this.form.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.form?.removeEventListener('change',this.update); }
  }
  customElements.define('ballr-addon-picker', AddonPicker);
  let busy = false;
  function root() { return window.Shopify?.routes?.root || '/'; }
  async function request(path, body) {
    const response = await fetch(root()+path, {method: body ? 'POST':'GET', credentials:'same-origin',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error('Cart request failed');
    return data;
  }
  // Keep checkout and quantity edits from racing the two cart operations.
  document.addEventListener('click', event => {
    if (busy && !event.target.closest('[data-addon-status]')) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('submit',event=>{if(busy){event.preventDefault();event.stopImmediatePropagation();}},true);
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-addon-upgrade]');
    if (!button || button.disabled || busy) return;
    event.preventDefault();
    const card = button.closest('[data-addon-cart]');
    const status = card.querySelector('[data-addon-status]');
    const operation = 'addon-'+Date.now()+'-'+Math.random().toString(36).slice(2);
    const targetId = Number(button.dataset.targetVariant);
    let original = null;
    let removalAttempted = false;
    const propertiesKey = properties => JSON.stringify(Object.entries(properties || {}).sort(([a],[b]) => a.localeCompare(b)));
    const findOriginal = cart => {
      if (!original) return null;
      const matches = cart.items.filter(item => item.variant_id === original.variant_id &&
        propertiesKey(item.properties) === propertiesKey(original.properties) &&
        (item.selling_plan_allocation?.selling_plan?.id || null) === (original.selling_plan_allocation?.selling_plan?.id || null));
      if (matches.length > 1) throw new Error('Ambiguous original cart line');
      return matches[0];
    };
    const findAdded = cart => cart.items.find(item => item.variant_id === targetId && item.properties?._ballr_addon_change === operation);
    busy = true; button.disabled = true; card.setAttribute('aria-busy','true');
    status.hidden = false; status.textContent = card.dataset.updating;
    document.documentElement.classList.add('ballr-addon-updating');
    try {
      const before = await request('cart.js');
      const old = before.items.find(item=>item.key===button.dataset.lineKey);
      if (!old || old.quantity!==Number(button.dataset.quantity)) throw new Error('Cart changed');
      original = old;
      const properties = {...old.properties, _ballr_addon_change:operation};
      // Never retry a payment/cart mutation after an uncertain response.
      await request('cart/add.js',{items:[{id:targetId,quantity:old.quantity,properties}]});
      const added = await request('cart.js');
      const source = findOriginal(added);
      if (!findAdded(added) || !source || source.quantity !== old.quantity) throw new Error('New set not confirmed');
      // Automatic discounts change line keys when the temporary extra set crosses
      // a quantity threshold. Resolve both lines from their stable properties.
      removalAttempted = true;
      const after = await request('cart/change.js',{id:source.key,quantity:0});
      if (findOriginal(after) || !findAdded(after)) throw new Error('Replacement not confirmed');
      location.reload();
    } catch {
      // If the add succeeded but removal did not, remove only this newly added
      // combination. Existing customer lines are never deleted as a rollback.
      try {
        const current=await request('cart.js');
        const oldStillThere=findOriginal(current);
        const newLine=findAdded(current);
        if (!oldStillThere && newLine && removalAttempted) {location.reload();return;}
        if (newLine && (oldStillThere || !removalAttempted)) await request('cart/change.js',{id:newLine.key,quantity:0});
      } catch { /* Leave a visible review message; do not retry the add. */ }
      status.textContent = card.dataset.error;
      busy=false; card.removeAttribute('aria-busy');document.documentElement.classList.remove('ballr-addon-updating');
      // A fresh page establishes current quantities before another attempt.
      const review=document.createElement('a');review.href=root()+'cart';review.textContent=card.dataset.review;status.append(' ',review);
    }
  });
})();
